import { makeGetRequest } from "../../../utils/lambda/requests"
import updateTC from "./tAndC"
import TCManager from "../../Legal/termsAndConditionsState"

export const redirectToHelpdesk = ({ location: { search } }) =>
  makeGetRequest({
    url: `/helpdesk_v1/federation/access?${search
      .split("&")
      .map((el) => el.split("?"))
      .flat()
      .filter(Boolean)
      .map((el) => el.split("="))
      .filter(([key]) => key !== "refer")
      .reduce((acc, [key, value]) => `${acc}&${key}=${value}`, "")}`,
    onSuccess: ({ access_url }) => window.location.replace(access_url),
    onFailure: console.error,
  })

export default ({
  history,
  location,
  redirect_uri,
  refer,
  pathAppend,
  dispatch,
}) =>
  makeGetRequest({
    url: "/foundation_v1/me/terms-and-conditions",
    onSuccess: (tc) => {
      const tcManager = new TCManager({ tc, history })
      dispatch(updateTC(tcManager))
      if (!tcManager.userHasAcceptedAllThemeTCs())
        history.push(tcManager.nextOutstandingUrl())
      else if (redirect_uri) redirectToHelpdesk({ location })
      else if (refer) history.push(`${refer}`)
    },
    onFailure: (error) => {
      console.error(error)
      if (error.status === 401) history.push(`/logout${pathAppend}`)
    },
  })
